'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SELECT_NEMU = exports.SELECT_NEMU = 'SELECT_NEMU';

var selectMenu = exports.selectMenu = function selectMenu(key) {
    return {
        type: SELECT_NEMU,
        key: key
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/nav.js
// module id = 896
// module chunks = 0